<header class="bn-header d-flex justify-content-between">
    <div class="navbar-brand d-flex justify-content-start align-items-center m-0">
        <div class="pl-1 pr-4" >
        </div>
        <a class="pr-4 d-none d-sm-block">
            <div class="logo-bndes"></div>
        </a>
        <div class="titulo-sistema" id="titulo.sistema-ux4" ng-reflect-klass="titulo-sistema" ng-reflect-ng-class="[object Object]">
            Assinador BNDES
        </div>
    </div>

    <div *ngIf="exibirLogout" class="navbar-brand m-0 d-flex" style="cursor: pointer" ng-reflect-klass="navbar-brand m-0 d-flex" ng-reflect-ng-class="[object Object]">
        <span (click)="logout()">
            <i class="fa fa-sign-out" style="vertical-align: middle;"></i> Sair
        </span>
    </div>
</header>
<bn-container [exibirAside]="false">
    <!--<bn-nav nav nomeMenu="smd_spa"></bn-nav>-->
    <div main>
        <router-outlet></router-outlet>
    </div>
    <div aside></div>
</bn-container>
<bn-alerts></bn-alerts>
<bn-loading-overlay></bn-loading-overlay>